import { put, takeLatest } from 'redux-saga/effects';
import { FetchStatus } from 'data/core';
import { saveTasks } from 'data/tasks/slice';
import { saveCompanyTasksSagaAction } from '../actions';
import { saveCompanyTasks } from '../slice';
function* saveCompanyTasksSaga({ payload }) {
    const tasks = payload || [];
    yield put(saveCompanyTasks(tasks === null || tasks === void 0 ? void 0 : tasks.map((t)=>t.taskId)));
    yield put(saveTasks({
        data: tasks,
        fetchStatus: FetchStatus.Partial
    }));
}
export const watchSaveCompanyTasksSaga = function*() {
    yield takeLatest(saveCompanyTasksSagaAction.type, saveCompanyTasksSaga);
};
